import Vue from 'vue';
import GoogleMap from 'vuejs-google-maps';
import 'vuejs-google-maps/dist/vuejs-google-maps.css'

export default () => {
    const { apiKey, libraries } = {"apiKey":"AIzaSyBiJVj8NZeFgdRWBWvW7MH9eyQJ9UA932o","libraries":["places"]} || {}
    Vue.use(GoogleMap, {
        load: {
            apiKey,
            libraries
        }
    });
}
